<template>
  <p class="overline"><slot /></p>
</template>

<style scoped>
.overline {
  display: block;
  color: #4d96a9;
  font-size: 1rem;
  line-height: 1.125rem;
  letter-spacing: 0.25rem;
  text-transform: uppercase;
  font-weight: 900;
}
</style>
